import axios, { AxiosError } from 'axios';

const baseURL = import.meta.env.VITE_API_URL || '/api';

export const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Vlozeni XSRF-TOKEN cookie do X-XSRF-TOKEN headeru
api.interceptors.request.use((config) => {
  const csrfCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('XSRF-TOKEN='));
  if (csrfCookie) {
    const token = decodeURIComponent(csrfCookie.split('=')[1]);
    config.headers['X-XSRF-TOKEN'] = token;
  }
  return config;
});

// 401 → redirect na /login (kromě samotneho /auth/me, ktery se vola pro detekci stavu)
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      const url = error.config?.url ?? '';
      if (!url.includes('/auth/me') && !url.includes('/auth/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);
